<section class="sect-inicio">
    <div class="container-page">
        <div class="sect-inicio-cont">
            <div class="sect-inicio-titles">
                <h1>{{config.bannerSettings.title}}<br>
                    <span class="solo-h1-micro-home">{{config.bannerSettings.subtitle}}</span>
                </h1>
                <p [innerHTML]="config.bannerSettings.paragraph">
                </p>
            </div>
            <div class="sect-inicio-imgs">
                <img class="img-1" src="{{config.resources.bannerImage1Url}}" alt="">
                <img class="img-2" src="{{config.resources.bannerImage2Url}}" alt="">
            </div>
        </div>
    </div>
</section>
<section class="sect-cards">
    <div class="container-page">
        <div class="sect-cards-cont">
            <ng-container *ngFor="let card of config.cards; index as i">
                <ng-container *ngIf="i < cardsToShow">
                    <div class="basic-card">
                        <a href="{{card.ctaLink}}">
                            <img class="basic-card-img" src="{{card.imageUrl}}" alt="">
                            <div class="basic-card-info">
                                <p class="">{{card.paragraph}}</p>
                                <div class="centrar-boton">
                                    <a class="basic-card-btn" href="{{card.ctaLink}}">{{card.ctaText}}</a>
                                </div>
                            </div>
                        </a>
                    </div>
                </ng-container>         
            </ng-container>
        </div>
    </div>
</section>
<ng-container *ngIf="cardsToShow < config.cards.length">
    <div class="centrar-boton">
        <button (click)="showMoreCards()" class="btn-white">Ver más microescapes</button>
    </div>
</ng-container>